<template>
  <div>
    <form data-vv-scope="uploadFiles">
      <div class="row">
        <div v-if="$route.name === 'conventionInputForm'" class="col-3 text-center">
          <div class="text-left">
            <label>Formato de ingreso</label>
            <b-form-select
              class="w-100"
              data-cy="input-format"
              :value="value"
              :options="inputFormatOptions"
              @change="$emit('input', $event)"
              :disabled="fromDocDigital"
            />
          </div>
        </div>
        <div class="col-9 mt-5" :class="{
          'd-none': (
            $route.name === 'conventionInputForm'
            && value === 'paper'
            && $route.params.from !== 'edit'
          )
        }">
          <div class="d-flex">
            <b-form-select
              class="w-100 mt-2 mr-4"
              v-model="uploadType"
              :options="optionsUploadTypes"
            />
            <UploadFile
              data-cy="file-upload"
              :maxSizeInMb="getMaxSize"
              v-if="uploadType === 'main'"
              class="mt-2 mr-3"
              permission="*"
              accept="application/pdf"
              text="Seleccionar"
              v-model="mainFile"
              upload-to="ed"
              v-tooltip="'Agregar archivo adjunto'"
            />
            <UploadFile
              v-if="uploadType === 'attached'"
              class="mt-2"
              permission="*"
              text="Seleccionar"
              accept="*"
              v-model="additionalFile"
              upload-to="ed"
              v-show="thereIsMainFile"
              @input="addAdditionalFile()"
              v-tooltip="'Agregar archivo adjunto'"
            />
            <AttachExistingFile
              v-if="uploadType.match(/existingMainFile|existingAttachment/i)"
              :uploadType="uploadType"
              class="mt-2"
              :thereIsMainFile="thereIsMainFile"
            />
            <div v-if="uploadType === 'main' && isResponse">
              Si el archivo que estás adjuntando va para firma, no debe pesar mas de 10 MB
            </div>
          </div>
        </div>
        <div class="col-12 mt-5" v-if="thereIsMainFile" :class="{
          'd-none': (
            $route.name === 'conventionInputForm'
            && value === 'paper'
            && $route.params.from !== 'edit'
          )
        }">
          <b-table-simple hover small>
            <b-thead>
              <b-tr>
                <b-th scope="col">Nombre archivo</b-th>
                <b-th scope="col">Nombre documento</b-th>
                <b-th scope="col" class="text-center">Acción</b-th>
                <b-th v-if="withClassification" scope="col" class="text-center">Interno</b-th>
                <b-th
                  v-if="withTrueCopy || $route.params.from === 'edit'"
                  scope="col"
                  class="text-center"
                >
                  Tipo
                </b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-td>
                  <div v-tooltip="'Principal'" class="d-flex align-items-center">
                    <vs-icon icon="file_present" size="medium" class="mr-1"/>
                    {{mainFile.name}}
                  </div>
                </b-td>
                <b-td>
                  <vs-input class="w-100" v-model="mainFile.currentDescription"/>
                </b-td>
                <b-td>
                </b-td>
                <b-td v-if="withTrueCopy || $route.params.from === 'edit'" class="text-center">
                  <b-form-select v-model="mainFile.trueCopy" :options="trueCopyOptions">
                  </b-form-select>
                </b-td>
              </b-tr>
              <b-tr v-for="file in additionalFiles" :key="file.id">
                <b-td>
                  <div v-tooltip="'Adjunto'" class="d-flex align-items-center">
                    <vs-icon icon="description" size="medium" class="mr-1"/>
                    {{file.name}}
                  </div>
                </b-td>
                <b-td>
                  <vs-input class="w-100" v-model="file.currentDescription"/>
                </b-td>
                <b-td class="text-center">
                  <vs-icon
                    data-cy="remove-attachment"
                    class="cursor-pointer"
                    icon="remove_circle_outline"
                    size="small"
                    v-tooltip="'Eliminar'"
                    color="danger"
                    @click="removeAdditionalFile(file.id)"
                  />
                </b-td>
                <b-td v-if="withClassification" class="text-center">
                  <vs-checkbox class="ml-5 pl-5" v-model="file.interno"/>
                </b-td>
                <b-td v-if="withTrueCopy || $route.params.from === 'edit'" class="text-center">
                  <b-form-select v-model="file.trueCopy" :options="trueCopyOptions">
                  </b-form-select>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AttachExistingFile from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/AttachExistingFile';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';

export default {
  name: 'loadFiles',
  props: {
    withClassification: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    },
    withTrueCopy: {
      type: Boolean
    },
    step: {
      type: Object
    }
  },
  components: { UploadFile, AttachExistingFile },
  data() {
    const { wizard } = this.$route.params;
    return {
      isResponse: wizard === 'numOf',
      mainFile: {},
      additionalFile: {},
      additionalFiles: [],
      error: '',
      uploadType: 'main',
      isPaper: 'Papel',
      inputFormatOptions: [
        { text: 'Papel', value: 'paper' },
        { text: 'Papel y Digital', value: 'paper_digital' },
        { text: 'Digital', value: 'digital' },
      ],
      uploadTypes: [
        {
          value: 'main',
          text: 'Seleccionar archivo principal (Nuevo)'
        },
        {
          value: 'attached',
          text: 'Seleccionar archivo adjunto (Nuevo)'
        }
      ],
      trueCopyOptions: [
        { text: 'Papel', value: 'Papel' },
        { text: 'Digital', value: 'Digital' }
      ]
    };
  },
  watch: {
    mainFile() {
      if (Object.keys(this.mainFile).length && !this.mainFile.trueCopy) {
        this.mainFile.trueCopy = this.isPaper;
      }
      this.$emit('mainFile', this.mainFile);
    },
    additionalFiles() {
      this.$emit('additionalFiles', this.additionalFiles);
    },
    value(val) {
      if (val === 'paper' && this.$route.params.from !== 'edit') {
        this.mainFile = {};
        this.additionalFiles = [];
      }
    },
    wizardStorage() {
      this.clearData();
    },
    detailsFile() {
      this.clearData();
    }
  },
  computed: {
    ...mapGetters('Dnts', [
      'loading',
      'detailsFile',
      'communes',
      'loading',
      'wizardStorage',
      'attachmentsFile'
    ]),
    ...mapGetters('Empresas', ['company']),
    getMaxSize() {
      if (this.isResponse) {
        return 10;
      }
      return undefined;
    },
    thereAreFiles() {
      return Object.keys(this.mainFile)?.length || this.additionalFiles?.length;
    },
    thereIsMainFile() {
      return Object.keys(this.mainFile)?.length && this.mainFile.name;
    },
    fromDocDigital() {
      return this.$route.params.from === 'docDigital';
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    optionsUploadTypes() {
      if (this.isSiss) {
        this.setModelUploadType('attached');
        return this.uploadTypes.filter((type) => type.value !== 'main');
      }
      return this.uploadTypes;
    }
  },
  methods: {
    clearData() {
      this.mainFile = {};
      this.additionalFiles = [];
    },
    setModelUploadType(type) {
      this.uploadType = type;
    },
    setFile(file) {
      this.additionalFile = file;
    },
    async addAdditionalFile() {
      if (!Object.keys(this.additionalFile).length) {
        return;
      }

      if (this.additionalFile.failed) {
        this.error = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }
      const newFile = { ...this.additionalFile };
      if (this.withTrueCopy) newFile.trueCopy = this.isPaper;
      this.additionalFiles.push(newFile);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.additionalFiles = this.additionalFiles.filter((file) => file.id !== fileId);
    },
    getInputFormatValue() {
      const format = this.detailsFile.dnt.transporteEmbalajeSello;
      let inputFormat = '';
      if (format === 'Papel') inputFormat = 'paper';
      if (format === 'Papel y Digital') inputFormat = 'paper_digital';
      if (format === 'Digital') inputFormat = 'digital';
      return inputFormat;
    },
  },
  created() {
    this.clearData();
    const files = this.wizardStorage?.archivos
      ? this.wizardStorage.archivos
      : this.attachmentsFile;

    if (this.$route.name === 'files' || this.$route.name === 'conventionInputForm') {
      const inputFormat = this.inputFormatOptions.find(
        (option) => option.text === this.detailsFile?.dnt?.transporteEmbalajeSello
      )?.value;
      if (inputFormat) {
        this.$emit('input', inputFormat);
      }
    }
    if (this.$route.params.from === 'docDigital') {
      this.$emit('input', 'digital');
    }

    if (this.step && this.step.mainFile.id) {
      this.mainFile = {
        ...this.step.mainFile,
        trueCopy: this.withTrueCopy ? this.isPaper : null
      };
    } else if (this.step && (this.step.febosId !== this.detailsFile.febosId)) {
      this.clearData();
    } else {
      const file = (files || []).find((current) => current.tipo === 'principal');
      if (typeof file === 'undefined') {
        this.mainFile = {};
      } else {
        this.mainFile = {
          id: file.adjuntoId,
          name: file.adjuntoNombre,
          mime: file.adjuntoMime,
          date: file.fecha,
          path: file.adjuntoUrl,
          status: file.estado || 0,
          currentDescription: file.tipoDescripcion,
          trueCopy: file.otraReferenciaId
        } || {};
      }
    }

    if (this.step && this.step.additionalFiles.length) {
      this.additionalFiles = [...this.step.additionalFiles];
    } else if (this.step && (this.step.febosId !== this.detailsFile.febosId)) {
      this.clearData();
    } else {
      this.additionalFiles = (files || [])
        .filter((file) => file.tipo === 'adjunto')
        .map((file) => ({
          id: file.adjuntoId,
          name: file.adjuntoNombre,
          mime: file.adjuntoMime,
          date: file.fecha,
          path: file.adjuntoUrl,
          currentDescription: file.tipoDescripcion,
          status: file.estado || 0,
          trueCopy: file.otraReferenciaId
        }));
    }
    if (this.$route.name === 'conventionInputForm' && !['draftTray', 'edit'].includes(this.$route.params.from)) {
      this.clearData();
    }
  }
};
</script>
